<template>
  <section class="policies_container">
    <section class="policies_content_container">
      <article
        v-for="(art, index) in policiesData"
        :key="index"
        class="policy_article"
      >
        <p>{{ art.title }}</p>
        <p v-if="Array.isArray(art.content)">
          <span v-for="(item, index) in art.content" :key="index">
            <a v-if="item.type === 'link'" :href="item.link" target="_blank">{{
              item.value
            }}</a>
            <span v-else>{{ item.value }}</span>
          </span>
        </p>

        <p v-else>{{ art.content }}</p>
      </article>
    </section>
    <WaveFooter />
  </section>
</template>

<script>
import WaveFooter from "@/components/WavFooter";
export default {
  name: "Policies",
  components: {
    WaveFooter,
  },
  computed: {
    policiesData() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].policies;
    },
  },
};
</script>

<style></style>
